<template>
    <div class="login-content">
        <div class="logoContainer">
            <div class="logo">
                <img src="../../static/logo1.png" alt="">
                <img style="width: 92px;height: auto;" src="../../static/logo-text.png" alt="">
            </div>

            <div class="leftContainer">
                <div class="title">
                    <h1>欢迎来到云销客</h1>
                    <div>
                        <span>使用手机号登录/注册</span>
                    </div>
                </div>
                <div class="login-form">
                    <a-input-group compact>
                        <a-select default-value="+86">
                            <a-select-option value="+86">
                            +86
                            </a-select-option>
                            <a-select-option value="Jiangsu">
                            Jiangsu
                            </a-select-option>
                        </a-select>
                        <a-input v-model="phone" style="width: 50%" placeholder="请输入手机号" />
                    </a-input-group>
                    <a-input ref="userNameInput" v-model="code" placeholder="请输入验证码">
                        <a @click="getcode" slot="suffix" href="javascript:;">{{codetext}}</a>
                    </a-input>
                    <a-row>
                        <a-col>
                            <a-checkbox  @change="onChange">同意《云销客用户协议》及《云销客隐私权政策》</a-checkbox>
                        </a-col>
                    </a-row>

                    <a-button @click="login" type="primary" :size="size">进入CRM</a-button>

                    <a-divider>进入第三方</a-divider>
                    <a href="">
                        <img class="wx" src="../../static/wx.png" alt="">
                    </a>
        
                </div>
 
            </div>
        </div>
        
        <div class="rightContainer"></div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            size:'large',
            phone:"",
            code:"",
            codetext:'获取验证码',
            flag:""
        }
    },
    methods:{
        // 获取验证码
        getcode(){
            var phone=this.phone
            if(phone==""){
               this.$message.error('请输入号码');
            }else if(!phone.match(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)){
                this.$message.error('请输入正确的号码格式');
            }else{
                 //倒计时
                let time = 60;
                let timer = setInterval(() => {
                if(time == 0) {
                    clearInterval(timer);
                    // this.disabled = false;
                    this.codetext = "获取验证码";
                } else {
                    this.codetext =time + '秒后重试';
                    // this.disabled = true;
                    time--
                }
                },1000)
                var params=new URLSearchParams()
                params.append('phone',phone)
                params.append('type',1)
                this.$axios.post('/api/sendsms',params,
                {
                    headers: {
                        "appid": this.appSet.appid,
                        "appkey": this.appSet.appkey,
                    }
                }).then((res)=>{
                    if(res.data.code==200){
                        this.$message.success(res.data.msg);
                    }else{
                        this.$message.error(res.data.msg);
                    }
                });
            }
        },
        onChange(e){
            this.flag=e.target.checked
        },
        login(){
            if(this.flag==true){
                var params=new URLSearchParams()
                params.append('phone',this.phone)
                params.append('code',this.code)
                this.$axios.post('/api/login',params,{
                    headers: {
                        "appid": this.appSet.appid,
                        "appkey": this.appSet.appkey,
                    }
                }).then((res)=>{
                    if(res.data.code==200){
                        if(res.data.data.is_true==2){
                            localStorage.setItem('token', res.data.data.token);
                            localStorage.setItem('platform', res.data.data.type);
                            this.$router.push({ path:'/register'  })
                        }else{
                            localStorage.setItem('platform', res.data.data.type);
                            localStorage.setItem('token', res.data.data.token);
                            this.$router.push({ path:'/'  })
  
                        }
                        
                    }else{
                        this.$message.error(res.data.msg);
                    }
                })
            }else{
                this.$message.error('请勾选协议');
            }
            
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/login.vue